import script from "./webApp.vue?vue&type=script&setup=true&lang=js"
export * from "./webApp.vue?vue&type=script&setup=true&lang=js"

import "./webApp.vue?vue&type=style&index=0&id=a95b3ef8&lang=scss"

const __exports__ = script;

export default __exports__